/**
 * password.js — Affichage des mots de passe profil (stockés en clair).
 *
 * Les comptes créés/modifiés entre le 26/05 et le correctif contiennent un hash
 * bcrypt ($2b$10$...) : on ne l'affiche jamais, l'admin doit le réinitialiser.
 * Même détection que api/libs/password.js.
 */
const BCRYPT_HASH = /^\$2[aby]\$\d{2}\$.{53}$/;

export function isHashedPassword(value) {
  return typeof value === "string" && BCRYPT_HASH.test(value);
}

// Lecture (fiche élève/parent/enseignant).
export function displayPassword(value) {
  return isHashedPassword(value) ? "à réinitialiser" : value;
}

// Pré-remplissage du formulaire d'édition : champ vide pour un hash,
// le champ étant requis l'admin doit saisir un nouveau mot de passe.
export function editablePassword(value) {
  return isHashedPassword(value) ? "" : value;
}

// Nouveau parent : règle de l'école, prénom en minuscules sans espaces + 123456
// (suivie par 96 % des comptes existants ; même règle que
// api/scripts/repairHashedPasswords.js).
export function defaultParentPassword(firstName) {
  const name = String(firstName || "").replace(/\s+/g, "").toLowerCase();
  return name ? `${name}123456` : "";
}
